import React, { useState } from 'react';
import { Drawer } from 'antd';
import { CloseOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { CiSettings } from 'react-icons/ci';
import { SettingsModalItem } from '../common/tab-items/settings-modal.items';

interface SettingsMobileDrawerProps {
  open: boolean;
  onClose: () => void;
  items: SettingsModalItem[];
}

const SettingsMobileDrawer = ({
  open,
  onClose,
  items,
}: SettingsMobileDrawerProps) => {
  const [activeKey, setActiveKey] = useState<string | null>(null);
  const activeItem = items.find(item => item.key === activeKey);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="bottom"
      height="auto"
      closeIcon={false}
      className="bottom-drawer-menu"
      title={
        <div className="flex items-center gap-3">
          {activeItem ? (
            <button
              type="button"
              onClick={() => setActiveKey(null)}
              aria-label="Kthehu"
              className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-[#003666] hover:bg-gray-100"
            >
              <LeftOutlined />
            </button>
          ) : (
            <CiSettings className="h-7 w-7 flex-shrink-0 text-[#ff731d]" />
          )}
          <span className="truncate text-lg font-semibold text-[#ff731d]">
            {activeItem?.title ?? 'Account Settings'}
          </span>
        </div>
      }
      extra={
        <button
          type="button"
          onClick={onClose}
          aria-label="Mbyll"
          className="flex h-8 w-8 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100"
        >
          <CloseOutlined />
        </button>
      }
      styles={{
        header: { borderBottom: '2px solid #0acaf9', padding: '16px 20px' },
        body: activeItem
          ? { padding: '8px 8px 24px', maxHeight: '80vh' }
          : { padding: 0 },
      }}
    >
      {activeItem ? (
        <div className="safe-bottom">{activeItem.children}</div>
      ) : (
        <div className="safe-bottom pb-4">
          {items.map(item => (
            <button
              key={item.key}
              type="button"
              onClick={() => setActiveKey(item.key)}
              className="flex w-full items-center gap-4 border-l-4 border-transparent px-6 py-4 text-left transition-all hover:bg-gray-50"
            >
              <span className="text-xl text-gray-600">{item.icon}</span>
              <span className="flex-1 text-base font-medium text-[#003666]">
                {item.title}
              </span>
              <RightOutlined className="text-xs text-gray-400" />
            </button>
          ))}
        </div>
      )}
    </Drawer>
  );
};

export default SettingsMobileDrawer;
